export default "<div class=\"loaderContainer\" *ngIf=\"model\">\n    <ng-lottie [options]=\"loaderOptions\" [styles]=\"loaderStyles\"></ng-lottie>\n</div>"